import api from '../api';

export async function checkInToken(token: string) {
    return api.get(`/api/check-in?token=${token}`);
}
